<template>
    <v-row justify="start" class="flex-nowrap ma-n4" :class="{ 'mt-n12': isItemSequent }">
        <v-col cols="auto" class="pa-4" :style="{ opacity: isItemSequent ? 0 : 1 }">
            <v-avatar color="grey-f7" height="28px!important" width="28px!important">
                <v-img>
                    <template #placeholder>
                        <v-icon small color="grey lighten-2"> mdi-robot </v-icon>
                    </template>
                </v-img>
            </v-avatar>
        </v-col>
        <v-col class="pa-4">
            <v-row align="end" class="ma-n4 flex-nowrap">
                <v-col cols="auto" class="pa-4" style="max-width: calc(100% - 36px)">
                    <v-card color="grey-f7" flat min-height="36">
                        <v-card-text class="py-8 px-12 font-size-14" style="word-break: break-all">
                            {{ message?.content }}
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="auto" class="pa-4" :style="{ opacity: isTimeSequent ? 0 : 1 }">
                    <span class="font-size-10">
                        {{ time }}
                    </span>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";
import { mapGetters } from "vuex";
import { CHAT_MESSAGE_TYPES, initChatMessage } from "@/store/chat";

export default {
    props: {
        index: { type: Number, default: 0 },
        message: { type: Object, default: initChatMessage },
    },
    computed: {
        ...mapGetters("chat", ["messages"]),
        time() {
            return dayjs(this.message?.createdAt).format("HH:mm");
        },
        isItemSequent() {
            if (this.index == 0) return false;
            const prev = this.messages[this.index - 1];
            return [CHAT_MESSAGE_TYPES.PROMPT_ALERT.value, CHAT_MESSAGE_TYPES.PROMPT_REPLY.value].includes(prev?.type);
        },
        isTimeSequent() {
            if (this.index == this.messages.length - 1) return false;

            const next = this.messages[this.index + 1];
            if (![CHAT_MESSAGE_TYPES.PROMPT_ALERT.value, CHAT_MESSAGE_TYPES.PROMPT_REPLY.value].includes(next?.type)) return false;

            return dayjs(next?.createdAt).format("HH:mm") == this.time;
        },
    },
};
</script>

